import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    paper: {
      maxWidth: 420,
      position: 'relative',
    },
    header: {
      padding: theme.spacing(2.5),
      border: 0,
    },
    headerButtonClose: {
      position: 'absolute',
      top: '10px',
      right: '10px',

      '& svg': {
        fontSize: theme.typography.pxToRem(18),
      },
    },
    dialogContent: {
      padding: theme.spacing(0, 3, 3),
      borderRadius: theme.shape.borderRadius,
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
    },
    icon: {
      width: 40,
      height: 40,
    },
    title: {
      margin: theme.spacing(1, 0, 1),
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(30),
      fontFamily: theme.typography.fontRobotoSlab,
      fontWeight: theme.typography.fontWeightSemiBold,
      color: COLORS.success.default,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: theme.typography.pxToRem(20),
      lineHeight: theme.typography.pxToRem(28),
      fontFamily: theme.typography.fontRobotoSlab,
      fontWeight: theme.typography.fontWeightSemiBold,
      textAlign: 'center',
    },
    description: {
      margin: theme.spacing(3, 0, 5),
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(24),
      textAlign: 'center',
    },
    button: {
      width: '100%',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      fontWeight: theme.typography.fontWeightMedium,
    },
  }),
  { name: 'UpgradePopup' }
);
